import { LocalizedStringDto } from '@order-mage/integration-sdk';

const hasLocalizedString = (value: LocalizedStringDto | null | undefined): boolean => {
    if (!value) return false;
    return Object.values(value).some((entry) => typeof entry === 'string' && entry.length > 0);
};

const hasItems = <T>(arr: readonly T[] | null | undefined): boolean => Array.isArray(arr) && arr.length > 0;

type ParentFallbackFields = {
    assets?: readonly { fullUrl?: string | null }[] | null;
    shortDescription?: LocalizedStringDto | null;
    description?: LocalizedStringDto | null;
    addons?: readonly { id?: string }[] | null;
    allergens?: readonly { id: string }[] | null;
};

/** Merge variant fields that fall back to parent when empty. */
export const applyParentFallbacks = <T extends ParentFallbackFields>(variant: T, parent: T): T => ({
    ...variant,
    assets: hasItems(variant.assets) ? variant.assets : parent.assets,
    shortDescription: hasLocalizedString(variant.shortDescription)
        ? variant.shortDescription
        : parent.shortDescription,
    description: hasLocalizedString(variant.description) ? variant.description : parent.description,
    addons: hasItems(variant.addons) ? variant.addons : parent.addons,
    allergens: hasItems(variant.allergens) ? variant.allergens : parent.allergens,
});
